<template>
    <v-dialog v-model="dialog" persistent :max-width="width">
        <v-card style="border-radius: 10px;">
            <p class="dialog-header"><v-spacer /><v-icon @click="confirm(false)" class="mx-1 my-1 white--text pointer">close</v-icon></p>
            <!-- <v-card-title class="headline">{{ $t(title) }}</v-card-title> -->
            <v-card-text style="font-size:19px">
                <slot name="body">
                    <center>{{ $t(body) }}</center>
                </slot>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <!-- <v-spacer></v-spacer> -->
                <v-btn v-if="cancelText" text @click="confirm(false)">{{ $t(cancelText) }}</v-btn>
                <v-btn
                    v-if="yesText"
                    dark
                    depressed
                    :color="$vuetify.theme.themes.dark.primary"
                    style="margin-right:30px;"
                    class="rounded-btn px-4"
                    @click="confirm(true)"
                    >{{ $t(yesText) }}</v-btn
                >
                <v-btn
                    v-if="noText"
                    outlined
                    :color="$vuetify.theme.themes.dark.primary"
                    style="margin-left:30px;"
                    class="mr-1 rounded-btn px-4"
                    @click="confirm(false)"
                    >{{ $t(noText) }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: {
            type: String
        },
        body: {
            type: String
        },
        yesText: {
            type: String,
            default: 'Да'
        },
        noText: {
            type: String,
            default: 'Нет'
        },
        cancelText: {
            type: String
        },
        width: {
            type: Number,
            default: 450
        }
    },
    data() {
        return {
            dialog: false,
            resolve: null
        };
    },
    methods: {
        show() {
            this.dialog = true;
            let outer = this;
            return new Promise(function(resolve) {
                outer.resolve = resolve;
            });
        },
        confirm(yes) {
            this.dialog = false;
            this.resolve(yes);
            this.resolve = null;
        }
    }
};
</script>

<style>
.dialog-header {
    background-color: #363e59;
    text-align: end;
}
</style>
